import * as React from 'react';
import classNames from 'classnames';
import { Media } from '../../../common/Media/Media.esm.js';
import { NvMarkdownInline, NvHeading, NvMarkdown } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import { useContentfulMedia } from '../../../hooks/useContentfulMedia.esm.js';
import styles from './ColumnSectionItem.module.esm.js';

var ColumnSectionItem = function (_a) {
    var _b;
    var id = _a.id, _c = _a.fields, heading = _c.heading, body = _c.body, button = _c.button, image = _c.image, vimeoId = _c.vimeoId, _d = _c.hideImageOnMobile, hideImageOnMobile = _d === void 0 ? false : _d, media = _c.media, _e = _a.classes, classes = _e === void 0 ? {} : _e;
    var videoFields = useContentfulMedia(media).videoFields;
    return (React.createElement("li", { className: classNames(styles.root, classes.root, classes.columnContainer), "data-testid": "columns-item-".concat(id), id: id },
        React.createElement("div", { className: styles.imageBodyContainer },
            (image || vimeoId || videoFields) && (React.createElement("div", { className: classNames(styles.mediaContainer, (_b = {},
                    _b[styles.hideImageOnMobile] = !!image && !!hideImageOnMobile,
                    _b[classes.videoHeight] = !!vimeoId || !!videoFields,
                    _b[styles.videoContainer] = !!vimeoId || !!videoFields,
                    _b)) },
                React.createElement(Media, { image: image, videoFields: videoFields, vimeoId: vimeoId }))),
            React.createElement("div", { className: styles.textContainer },
                heading && (React.createElement(NvMarkdownInline, { className: classNames(styles.alignment, styles.header, classes.alignment), element: "h3", elementWrapper: NvHeading, level: 3 }, heading)),
                body && (React.createElement(NvMarkdown, { className: classNames(styles.alignment, styles.body, classes.alignment, classes.itemsList) }, body)),
                button && (React.createElement("div", { className: classNames(styles.alignment, classes.alignment) },
                    React.createElement(BaseNucleobaseComponent, { classes: { link: 'nv-button' }, source: button })))))));
};

export { ColumnSectionItem as default };
//# sourceMappingURL=ColumnSectionItem.esm.js.map
